/**
 * 订单管理 交易订单
 */
<template>
  <div>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="订单号">
        <el-input
          size="small"
          v-model="formInline.OrderID"
          placeholder="输入订单号"
        ></el-input>
      </el-form-item>
      <el-form-item label="商品名称">
        <el-input
          size="small"
          v-model="formInline.CommodityName"
          @blur="changeCommodityName"
          placeholder="输入商品名称"
        ></el-input>
      </el-form-item>

      <el-form-item label="下单时间">
        <el-date-picker
          size="mini"
          v-model="formInline.time"
          type="daterange"
          value-format="yyyy-MM-dd"
          format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="请选择日期"
          end-placeholder="请选择日期"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="状态">
        <el-select
          size="small"
          v-model="formInline.OrderState"
          placeholder="请选择"
        >
          <el-option
            v-for="type in OrderStates"
            :label="type.key"
            :value="type.key"
            :key="type.key"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="类型">
        <el-select
          size="small"
          v-model="formInline.OrderType"
          placeholder="请选择"
        >
          <el-option
            v-for="type in OrderStates1"
            :label="type.key"
            :value="type.key"
            :key="type.key"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button
          size="small"
          type="primary"
          icon="el-icon-search"
          @click="search"
          >搜索</el-button
        >
        <el-button
          size="small"
          type="primary"
          icon="el-icon-download"
          @click="leadout"
          >导出</el-button
        >
      </el-form-item>
    </el-form>
    <!--列表-->

    <el-table
      size="small"
      :data="listData"
      highlight-current-row
      v-loading="loading"
      border
      height="60vh"
      element-loading-text="拼命加载中"
      style="width: 100%"
    >
      <el-table-column align="center" prop="OrderID" label="订单号">
        <template slot-scope="scope">
          <span @click="toDetail(scope.row)" class="text-blue pointer">{{
            scope.row.OrderID
          }}</span>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="CommodityName"
        label="商品名称"
      ></el-table-column>
      <el-table-column
        align="center"
        prop="CREATETIME"
        label="下单日期"
      ></el-table-column>
      <el-table-column
        align="center"
        prop="OrderType"
        label="订单类型"
      ></el-table-column>
      <el-table-column
        align="center"
        prop="Source"
        label="渠道来源"
      ></el-table-column>
      <el-table-column
        align="center"
        prop="Pieces"
        label="数量"
      ></el-table-column>
      <el-table-column
        align="center"
        prop="OrderState"
        label="订单状态"
      ></el-table-column>
      <el-table-column
        align="center"
        prop="OriginalPrice"
        label="销售价"
      ></el-table-column>
      <el-table-column
        align="center"
        prop="FTicketValue"
        label="艺年优惠券"
      ></el-table-column>
      <el-table-column
        align="center"
        prop="FullReductionAmount"
        label="翔会优惠券"
      ></el-table-column>
      <el-table-column
        align="center"
        prop="OrderAmount"
        label="实付款"
      ></el-table-column>
      <el-table-column
        align="center"
        prop="PayTime"
        label="收款时间"
      ></el-table-column>
      <el-table-column
        align="center"
        prop="Commission"
        label="手续费金额"
      ></el-table-column>
      <el-table-column
        align="center"
        prop="PayAmount"
        label="实际到款金额"
      ></el-table-column>
      <el-table-column
        align="center"
        prop="Consignee"
        label="客户名称"
      ></el-table-column>
      <el-table-column
        align="center"
        prop="ContactInformation"
        label="联系方式"
      ></el-table-column>
      <el-table-column
        align="center"
        prop="ShippingAddress"
        label="详细地址"
      ></el-table-column>
      <el-table-column
        align="center"
        prop="LogisticsNo"
        label="物流编号"
      ></el-table-column>
      <el-table-column
        align="center"
        prop="WeChatOrderNo"
        label="商户订单号"
      ></el-table-column>
      <el-table-column
        align="center"
        prop="Remark"
        label="后台备注"
      ></el-table-column>
    </el-table>

    <!-- 分页组件 -->
    <!-- <mPage
      :page="pageparm.currentPage"
      :total="pageparm.total"
      @change="changePage"
    ></mPage> -->
  </div>
</template>

<script>
import mPage from "../../components/mPage.vue";
let flag = true;
export default {
  components: { mPage },
  data() {
    return {
      CSetting: this.$Url + "BSetting/",
      goodUrl: this.$goodUrl,
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: "预览",
      OrderStates: [
        { key: "所有", value: "0" },
        { key: "待付款", value: "1" },
        { key: "待发货", value: "2" },
        { key: "待收货", value: "3" },
        { key: "已完成", value: "4" },
        { key: "已退款", value: "5" },
        { key: "已退货待退款", value: "6" },
        { key: "已退货已退款", value: "7" },
        { key: "仅退款", value: "8" }
      ],
      OrderStates1: [{ key: "所有" }, { key: "一口价" }, { key: "拍卖" }],
      formInline: {
        page: 0,
        limit: 10,
        OrderID: "",
        ShopName: "",
        ShopGUID: "",
        OrderState: "所有",
        OrderType: "所有",
        CommodityName: "",
        time: [],
      },
      // 删除部门
      seletedata: {
        ids: "",
        token: localStorage.getItem("logintoken"),
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 0,
        pageSize: 10,
        total: 10,
      },
      canNext: true,
      GlobalOrderID: "G9999123199999",
      selectedInfo: {},
      details: [],
    };
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.personInfo = JSON.parse(this.$util.getStore("personInfo"));
    this.getdata();
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    changeCommodityName(e){
      console.log(e,255)
    },
    sendGoods(e) {
      this.$prompt("物流单号", "发货", {
        confirmButtonText: "确定发货",
        showCancelButton: false,
        // inputType: "textarea",
        inputPattern: /^.+$/,
        customClass: "mflex",
        inputErrorMessage: "请输入要快递单号",
      })
        .then(({ value }) => {
          e.OrderState = "待收货";
          this.UpdateOrderState(e, value);
        })
        .catch(() => {
          console.log(39888);
          this.$message({
            type: "info",
            message: "取消输入",
          });
        });
    },
    deteteFn(e) {
      this.$confirm("是否确定退货?", "退货", {
        confirmButtonText: "确定",
        cancelButtonText: "关闭",
        type: "warning",
      })
        .then(() => {
          console.log(e, 3333);
          e.OrderState = "已退货";
          this.UpdateOrderState(e);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    UpdateOrderState(e, LogisticsNo = "") {
      this.$loading();
      this.$api
        .ExSqlFn("ShopWebApp\\UpdateOrderState_1_0_2&DBC=w_b1∑w_b2", {
          OrderState: e.OrderState,
          LogisticsNo: LogisticsNo,
          OrderDetailGUID: e.OrderDetailGUID,
        })
        .then((res) => {
          let result = res.data,
            list = {};
          this.$loading().close();
          if (result.OK != "True") {
            this.$message({
              message: result.Message,
              type: "success",
            });
          } else if (result.Tag[0] == 0) {
            this.$message({
              message: "修改失败",
              type: "success",
            });
          } else {
            this.$message({
              message: "修改成功",
              type: "success",
            });
          }
          this.getdata();
        });
    },
    changeFn(e) {
      this.$prompt("应收款", "改价", {
        confirmButtonText: "确定",
        showCancelButton: false,
        // inputType: "textarea",
        inputPattern: /^(?!(0[0-9]{0,}$))[0-9]{1,}[.][0-9]*[1-9]$/,
        customClass: "mflex",
        inputErrorMessage: "请输入大于0的金额",
      })
        .then(({ value }) => {
          this.$loading();
          this.$api
            .ExSqlFn("ShopWebApp\\UpdateOrderAmount_1_0_2&DBC=w_b1∑w_b2", {
              OrderAmount: value,
              OrderDetailGUID: e.OrderDetailGUID,
            })
            .then((res) => {
              let result = res.data,
                list = {};
              this.$loading().close();
              if (result.OK != "True") {
                this.$message({
                  message: result.Message,
                  type: "success",
                });
              } else if (result.Tag[0] == 0) {
                this.$message({
                  message: "修改失败",
                  type: "success",
                });
              } else {
                this.$message({
                  message: "修改成功",
                  type: "success",
                });
              }
              this.getdata();
            });
        })
        .catch(() => {
          console.log(39888);
          this.$message({
            type: "info",
            message: "取消输入",
          });
        });
    },
    remarkFn(e) {
      this.$prompt("备注", "备注", {
        confirmButtonText: "确定",
        showCancelButton: false,
        inputType: "textarea",
        inputPattern: /^.+$/,
        customClass: "mflex",
        inputErrorMessage: "请输入",
      })
        .then(({ value }) => {
          this.$loading();
          this.$api
            .ExSqlFn("Web\\UpdateOrderRemark_1_0_2&DBC=w_b1∑w_b2", {
              Remark: value,
              OrderGUID: e.OrderGUID,
            })
            .then((res) => {
              let result = res.data;
              this.$loading().close();
              if (result.OK != "True") {
                this.$message({
                  message: result.Message,
                  type: "success",
                });
              } else if (result.Tag[0] == 0) {
                this.$message({
                  message: "修改失败",
                  type: "success",
                });
              } else {
                this.$message({
                  message: "修改成功",
                  type: "success",
                });
              }
              this.getdata();
            });
        })
        .catch(() => {
          console.log(39888);
          this.$message({
            type: "info",
            message: "取消输入",
          });
        });
    },
    toDetail(e) {
      console.log(e, 45555);
      let a = {
        CREATETIME: e.CREATETIME,
        OrderID: e.OrderID,
        Consignee: e.Consignee,
        ContactInformation: e.ContactInformation,
        ShippingAddress: e.ShippingAddress,
        OrderGUID: e.OrderGUID,
      };
      this.$router.push({
        path: "/orderDetail",
        query: { item: JSON.stringify(a), from: 1 },
      });
    },
    changePage(e, i) {
      let { currentPage } = this.pageparm;
      if (e == 1) {
        currentPage = 0;
        // currentPage--;
        (this.GlobalOrderID = "G9999123199999"), (this.canNext = true);
      } else {
        if (this.canNext) {
          currentPage++;
        } else {
          this.pageparm.total = currentPage;
        }
      }
      console.log(currentPage, 1111);
      this.pageparm.currentPage = currentPage;
      this.formInline.page = currentPage;
      if (this.canNext) {
        this.getdata();
      }
    },
    // 获取公司列表
    getdata() {
      let {
          page,
          limit,
          OrderID,
          CommodityName,
          OrderState,
          ShopName,
          ShopGUID,
          time,
          OrderType,
        } = this.formInline,
        { CompanyGUID } = this.personInfo;
        console.log(this.formInline,5444)
      let data = {
          CompanyGUID,
          OrderID,
          ShopGUID,
          StartTime: "2000-01-01",
          EndTime: "9999-01-01",
          ShopName,
          CommodityName,
          OrderState,
          OrderType,
          GlobalOrderID: page > 0 ? this.GlobalOrderID : "G9999123199999",
        },
        list = [];
      console.log(time, 380,data);
      if (time && time.length > 0) {
        data.StartTime = time[0];
        data.EndTime = time[1];
      }
      this.$loading();
      this.$api
        .QueryDataFn1(
          "ShopWebApp\\GetFinancialStatementsList_1_0_4&DBC=r_b1∑r_b2",
          data
        )
        .then((res) => {
          let result = res.data;
          this.$loading().close();
          if (result.OK != "True") {
            this.$message({
              message: result.Message,
              type: "success",
            });
          } else if (result.Tag.length <= 0) {
          } else {
            list = result.Tag[0].Table;
            list.forEach((e) => {
              e.UserName = decodeURIComponent(e.UserName);
              e.Source = decodeURIComponent(e.Source);
            });
            this.canNext = list.length > 0 ? true : false;
            this.pageparm.total =
              list.length > 0
                ? this.pageparm.currentPage + 1
                : this.pageparm.currentPage;
            this.GlobalOrderID = list[list.length - 1].GlobalOrderID;
          }
          this.listData = list;
        });
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage;
      this.formInline.limit = parm.pageSize;
      this.getdata(this.formInline);
    },
    // 搜索事件
    search() {
      this.GlobalOrderID = "G9999123199999";
      this.formInline.page = 0;
      this.getdata(this.formInline);
    },
    leadout() {
      let {
          page,
          OrderID,
          CommodityName,
          OrderState,
          ShopName,
          ShopGUID,
          time,
          OrderType,
        } = this.formInline,
        { CompanyGUID } = this.personInfo;
      let data = {
        CompanyGUID,
        OrderID,
        ShopGUID,
        StartTime: "2000-01-01",
        EndTime: "9999-01-01",
        ShopName,
        CommodityName,
        OrderState,
        OrderType,
        GlobalOrderID: page > 0 ? this.GlobalOrderID : "G9999123199999",
      },sqlCmdName='ShopWebApp\\GetFinancialStatementsListReportForm_1_0_4&DBC=r_b1∑r_b2';
      if (time && time.length > 0) {
        data.StartTime = time[0];
        data.EndTime = time[1];
      }

      this.handleExport(sqlCmdName, data)
    },
    handleExport(sqlCmdName, data) {
      let that = this ,time=Date.parse(new Date()),OutputFileName='FinancialStatementsListReportForm'+ time+'.csv';
      that.$loading();
      data.OutputFileName=OutputFileName;
      that.$api.OutputCsv(sqlCmdName, data).then((r) => {
        console.log(res, 111111);
        that.$loading().close();
        let res = r.data;
        if (res.OK != "True") {
          that.$message(res.Message);
        } else {
          let url = that.$ReportForm + data.OutputFileName;
          window.open(url, "_blank");
        }
      });
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate((valid) => {
        if (valid) {
          ConfigSave(this.editForm)
            .then((res) => {
              this.editFormVisible = false;
              this.loading = false;
              if (res.success) {
                this.getdata(this.formInline);
                this.$message({
                  type: "success",
                  message: "公司保存成功！",
                });
              } else {
                this.$message({
                  type: "info",
                  message: res.msg,
                });
              }
            })
            .catch((err) => {
              this.editFormVisible = false;
              this.loading = false;
              this.$message.error("支付配置信息保存失败，请稍后再试！");
            });
        } else {
          return false;
        }
      });
    },
    // 删除公司
    deleteUser(index, row) {
      this.$confirm("确定要删除吗?", "信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          ConfigDelete(row.deptId)
            .then((res) => {
              if (res.success) {
                this.$message({
                  type: "success",
                  message: "公司已删除!",
                });
                this.getdata(this.formInline);
              } else {
                this.$message({
                  type: "info",
                  message: res.msg,
                });
              }
            })
            .catch((err) => {
              this.loading = false;
              this.$message.error("支付配置信息删除失败，请稍后再试！");
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 关闭编辑、增加弹出框
    closeDialog(formName) {
      this.editFormVisible = false;
      this.$refs[formName].resetFields();
    },
  },
};
</script>

<style scoped >
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
.eltable {
  border: 1px solid #ebeef5;
  max-height: 71vh;
  margin-bottom: 10px;
  overflow-y: scroll;
}
.title {
  border-bottom: 1px solid #ebeef5;
  line-height: 2;
  padding: 20px;
}
.grayBg {
  background: #eee;
  display: inline-block;
  width: 100px;
  padding: 0 20px;
  margin-right: 20px;
  border-right: 1px solid #ebeef5;
  text-align: center;
}
.grayBgBox {
  width: 500px;
  line-height: 3;
}
</style>

 
 

 


// WEBPACK FOOTER //
// src/views/shop/financial.vue